import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';
import Footer from 'pages/Login/footer/component';

export default styled(Footer)`
  background-color: var(--primary700);
  color: var(--white);
  height: 72px;
  ${media.lessThan('extraSmall')`
    height: 104px;
    background-color: #68747b;
  `};

  .wrap {
    display: flex;
    height: 100%;
    align-items: center;
    max-width: 880px;
    width: 100%;
    margin: 0 auto;
    padding: 0 32px;
    ${media.lessThan('extraSmall')`
      padding: 0 ${gridSizes('M')};
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
    `};
  }

  .left {
    margin: 0 32px 0 0;
    flex: 1;
    a {
      color: var(--white);
      white-space: nowrap;
      text-decoration: none;
    }

    ${media.lessThan('extraSmall')`
      flex: none;
      margin: 0;
      display: block;
    `};
  }

  .right > a {
    margin: 0 32px 0 0;
    font-weight: ${weights('bold')};
    &:last-child {
      margin: 0;
    }
    &:hover {
      filter: invert(8%);
    }

    ${media.lessThan('extraSmall')`
      margin: 12px ${gridSizes('L')} 0 0;
      background-color: #68747b;
    `};
  }
`;
